import { render, staticRenderFns } from "./Popup02.vue?vue&type=template&id=a17476fa&scoped=true"
import script from "./Popup02.vue?vue&type=script&lang=js"
export * from "./Popup02.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a17476fa",
  null
  
)

export default component.exports